import type { PjAgradaStatus } from './pjAgradaTypes'

export const PJ_AGRADA_STATUS_LABELS: Record<PjAgradaStatus, string> = {
  ATIVO: 'Ativo',
  INATIVO: 'Inativo',
  NAO_PREENCHIDO: 'Não preenchido',
  NAO_CONCLUIDO: 'Não concluído',
}

export const PJ_AGRADA_STATUS_CLASS: Record<PjAgradaStatus, string> = {
  ATIVO: 'bg-emerald-500/10 text-emerald-400',
  INATIVO: 'bg-amber-500/10 text-amber-400',
  NAO_PREENCHIDO: 'bg-yellow-500/10 text-yellow-400',
  NAO_CONCLUIDO: 'bg-orange-500/10 text-orange-400',
}

export const PJ_AGRADA_PLACEHOLDER_PHONE = '0000000000'

export function isPlaceholderPhone(telefone?: string | null): boolean {
  if (!telefone) return true
  const digits = telefone.replace(/\D/g, '')
  return digits === '' || digits === PJ_AGRADA_PLACEHOLDER_PHONE
}
